'use client';

import React from 'react';
import { Flex, keyframes } from '@shared/ui';

const spinnerAnimation = keyframes`
    0%    {transform: rotate(0deg)}
    100%  {transform: rotate(360deg)}
`;

const animation = `${spinnerAnimation} 0.6s linear infinite`;

export const Loading: React.FC = () => {
    return (
        <Flex
            boxSizing="border-box"
            alignItems="center"
            justifyContent="center"
            height="calc(100vh - var(--shop-ui-custom-site-header-height))"
            _after={{
                content: '""',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                margin: '1px',
                borderRadius: '50%',
                border: '3px solid',
                borderColor: 'neutral.030',
                borderTopColor: 'neutral.080',
                animation,
            }}
        />
    );
};
